import {
  Component, ElementRef, EventEmitter, HostListener, Input, OnChanges,
  OnInit,
  Output, SimpleChanges, ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { buildPrintDocument } from './print-document';

export interface PrintColumn<T = any> {
  /** Property name on each row object. */
  key: keyof T & string;
  header: string;
  align?: 'left' | 'right' | 'center';
  /** Optional formatter, e.g. currency or dates. */
  format?: (value: any, row: T) => string;
}

/**
 * Popup modal that previews a system-generated table and prints ONLY that table
 * (via a hidden iframe, so app styles never leak in).
 *
 * <app-print-modal [open]="show" title="Open orders"
 *                  [columns]="columns" [rows]="orders" (closed)="show = false" />
 */
@Component({
  selector: 'app-print-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './print-modal.component.html',
  styleUrl: './print-modal.component.scss',
})
export class PrintModalComponent<T = any> implements OnChanges, OnInit {
  @Input() open = false;
  @Input() title = 'Report';
  @Input() columns: PrintColumn<T>[] = [];
  @Input() rows: T[] = [];
  @Output() closed = new EventEmitter<void>();

  @ViewChild('printBtn') private printBtn?: ElementRef<HTMLButtonElement>;
  constructor(){
    console.log(this.columns);
  }
  ngOnInit(): void {
    console.log(this.columns);
  }
  protected today = new Date().toLocaleDateString(undefined, { dateStyle: 'long' });

  ngOnChanges(changes: SimpleChanges) {
    // Move focus into the dialog once it has rendered.
    if (changes['open']?.currentValue) {
      setTimeout(() => this.printBtn?.nativeElement.focus());
    }
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    if (this.open) this.closed.emit();
  }

  protected cell(row: T, col: PrintColumn<T>): string {
    const v = (row as any)[col.key];
    const out = col.format ? col.format(v, row) : v;
    
    return out == null || out === '' ? '—' : String(out);
  }

  print() {
    const iframe = document.createElement('iframe');
    iframe.setAttribute('aria-hidden', 'true');
    iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;';

    iframe.onload = () => {
      const win = iframe.contentWindow!;
      const cleanup = () => iframe.remove();
      win.addEventListener('afterprint', cleanup);
      setTimeout(cleanup, 60_000); // fallback for browsers that skip afterprint
      win.focus();
      win.print();
    };

    iframe.srcdoc = buildPrintDocument(
      this.title, this.today, this.columns, this.rows, (r, c) => this.cell(r, c),
    );
    document.body.appendChild(iframe);
  }
}